<template>
  <ion-menu side="start" contentId="main">
    <ion-header>
      <ion-toolbar>
        <ion-title>Start Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item @click="open('/home')"
          ><ion-icon name="home" slot="start"></ion-icon>Home</ion-item
        >
        <ion-item @click="open('/trip')"
          ><ion-icon name="airplane" slot="start"></ion-icon>My trips</ion-item
        >
        <ion-item @click="open('/home')"
          ><ion-icon name="mail" slot="start"></ion-icon>Messages</ion-item
        >
        <ion-item @click="open('/home')"
          ><ion-icon name="person" slot="start"></ion-icon>Profile</ion-item
        >
        <ion-item @click="logout"
          ><ion-icon name="exit" slot="start"></ion-icon>Logout</ion-item
        >
      </ion-list>
    </ion-content>
  </ion-menu>
</template>

<script>
import firebase from "firebase";
import auth from "@/store/modules/auth";

export default {
  name: "MainMenu",
  methods: {
    logout: async function() {
      await auth.logout();
      this.$router.replace("login");
    },
    open: function(route) {
      this.$router.push(route);
    }
  }
};
</script>

<style></style>
